import { GzExchangeAntimalwareRulesFormWebComponent } from './component/GzExchangeAntimalwareRulesFormWebComponent';

export { GzExchangeAntimalwareRulesFormWebComponent };
